import { z } from 'zod';
/**
 * Flood-It — spatial planning.
 *
 * A grid of coloured cells. The top-left cell owns a "blob" of all cells
 * connected to it in the same colour. Pick a colour: the blob repaints to it and
 * swallows any neighbouring cells of that colour, growing. Turn the whole board
 * one colour within a move budget.
 *
 * "Locked once achieved" holds: the blob only ever grows, never shrinks, so the
 * cells you have captured stay captured.
 */
export const FLOOD_COLORS = 6;
/** The palette, as CSS colours. Index into this with a cell's colour value. */
export const FLOOD_PALETTE = ['#ff4d4d', '#ffb020', '#a6ff2e', '#22e0ff', '#8b7dff', '#ff6ad5'];
export const FloodPickEvent = z.object({
    type: z.literal('pick'),
    /** Colour index to flood to. 0..FLOOD_COLORS-1. */
    color: z.number().int().min(0).max(FLOOD_COLORS - 1),
});
export const FloodEvent = z.discriminatedUnion('type', [FloodPickEvent]);
//# sourceMappingURL=flood-it.js.map